import * as React from 'react';
import { MessageBar, MessageBarBody } from '@fluentui/react-components';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  message: string | null;
}

/**
 * Catches render errors in the subtree and shows a fallback error message
 * instead of crashing the entire add-in to a white screen.
 */
export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, message: null };
  }

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    return {
      hasError: true,
      message:
        error instanceof Error
          ? error.message
          : 'An unexpected error occurred.',
    };
  }

  render() {
    if (this.state.hasError) {
      return (
        <MessageBar intent="error">
          <MessageBarBody>
            {this.state.message ?? 'An unexpected error occurred.'}
          </MessageBarBody>
        </MessageBar>
      );
    }
    return this.props.children;
  }
}
